module.exports = __webpack_public_path__ + "media/images/star-on-4a407d74.svg";